import { Grid, Link, Typography } from "@mui/material"
import footerStyles from "../../Styles/ComponentStyles/FooterStyles/Footer.module.scss"
import { LEGAL } from "../../config/legal"

type PublishedLegalPageProps = {
    title: string
    url: string
    version: string
}

// One in-app page for a legal text published on the product host (RB-326): the text is framed from its published URL so
// the app never carries a second copy, with the version and an open-in-a-new-tab link above the frame.
const PublishedLegalPage = ({ title, url, version }: PublishedLegalPageProps) => {
    return (
        <Grid container className={footerStyles.footerPagesMainComponent} justifyContent="center">
            <Grid item sm={11} xs={11} md={10} lg={9} xl={7} className={footerStyles.footerPagesTextContainer}>
                <Grid container className="paraData">
                    <Grid item sm={12} xs={12} textAlign="center" className={footerStyles.titleContainer}>
                        <Typography className={footerStyles.pageTitle} component="h1">{title}</Typography>
                    </Grid>
                    <Grid item sm={12} xs={12} textAlign="center">
                        <Typography component="p" className={footerStyles.textStyle} data-testid="legal-version">
                            {LEGAL.productName} {title}, version {version}.{' '}
                            <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover">
                                Open the published text in a new tab
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item sm={12} xs={12} padding={"30px"}>
                        <iframe
                            title={`${LEGAL.productName} ${title}`}
                            src={url}
                            data-testid="legal-frame"
                            style={{ width: '100%', height: '80vh', border: 'none', background: '#fff' }}
                            referrerPolicy="no-referrer"
                            loading="lazy"
                            sandbox="allow-popups allow-popups-to-escape-sandbox"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PublishedLegalPage
